import { QuantifyAnomaliesTableView } from '@modules/quantify/components/QuantifyAnomaliesTableView';
import { QuantifyTableViewContent } from '@modules/quantify/components/QuantifyTableView/QuantifyTableViewContent';
import { useIsAnomaliesTrendVisible } from '@modules/quantify/hooks';

interface QuantifyTableViewProps {
  shouldDisableInteraction?: boolean;
  shouldShowMergeWithSelectedReasonsAction?: boolean;
}

export const QuantifyTableView = ({
  shouldDisableInteraction = false,
  shouldShowMergeWithSelectedReasonsAction = true,
}: QuantifyTableViewProps) => {
  const isAnomaliesTrendVisible = useIsAnomaliesTrendVisible();

  if (isAnomaliesTrendVisible) {
    return (
      <QuantifyAnomaliesTableView
        shouldShowAddToFilter={!shouldDisableInteraction}
      />
    );
  }

  return (
    <QuantifyTableViewContent
      shouldShowActions={!shouldDisableInteraction}
      shouldShowMergeWithSelectedReasonsAction={
        shouldShowMergeWithSelectedReasonsAction
      }
    />
  );
};
